import React, { useEffect, useState } from 'react';
import { useParams, Link, useLocation, useHistory } from 'react-router-dom';
import DatePicker, { registerLocale} from "react-datepicker";
import ru from 'date-fns/locale/ru';
import axios from 'axios';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import 'moment/locale/ru';
import "pages/style.css";

registerLocale('ru', ru)
moment.locale('ru')

export function Events() {

    let { ID } = useParams();
    const location = useLocation();
    const { lastname, name, surname } = location.state
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [table, setTable] = useState([]);
    const url = "/api/get/events"
    let history = useHistory();

    const getInsp = () => {
        axios
            .post(url, { id: parseInt(ID), dtfrom: startDate, dtto: endDate })
            .then((resp) => {
                setTable(resp.data);
            });
    };

    const drawTable1 = () => {
        return (
            table.map((key) =>
                <div>
                    <h3>{key.Calls.typename}</h3>
                    <h4>{key.Calls.subtypename}</h4>
                    <h4>Количество:{" " + Object.keys(key.Calls.calls).length}</h4>
                    <table className='.ievents'>
                        <tbody>
                            <tr>
                                <th className='thead'>Дата</th>
                                <th>Мероприятие</th>
                            </tr>
                            {Object.keys(key.Calls.calls).map(key2 => (
                                <tr>
                                    <td>{moment(key.Calls.calls[key2].date).format('LL')}</td>
                                    <td>{key.Calls.calls[key2].value}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <br />
                </div>
            )
        )
    }

    useEffect(() => {
        <div>{drawTable1(table)}</div>
    })

    return (
        <div className='main'>
            <div className='insp'>
                <h3>{lastname + " " + name + " " + surname + " "}</h3>
                <Link to={{
                    pathname: `/edit/inspector/${ID}`,
                    state: { lastname: lastname, name: name, surname: surname }
                }}>
                    <button>Редактировать</button>
                </Link>
            </div>
            <br />
            <div>
                <DatePicker
                    //isClearable
                    dateFormat="dd.MM.yyyy"
                    placeholderText='Начало периода'
                    locale={ru}
                    selected={startDate}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(date) => setStartDate(date)} />


                <DatePicker
                    //isClearable
                    dateFormat="dd.MM.yyyy"
                    placeholderText='Конец периода'
                    locale={ru}
                    selected={endDate}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    onChange={(date) => setEndDate(date)} />
            </div>
            <button onClick={getInsp}>Запросить</button>
            <button onClick={history.goBack}>Назад</button>

            {drawTable1(table)}

        </div>
    )
}
